import { createAction, handleActions } from 'redux-actions'
import Moment from 'moment'
import * as globalMessageActions from '../global-message'
import * as pageActions from '../page'
import HylteLogo from '../../common/images/hyltesimlogo.png'

const SET_LOCALES = createAction('locales/SET_LOCALES')
const SET_LANGUAGE = createAction('locales/SET_LANGUAGE')
const SET_COUNTRY = createAction('locales/SET_COUNTRY')
const SET_LOGO = createAction('locales/SET_LOGO')

const initialState = { locales: null, language: null, country: null, logo: null }

export default handleActions(
  {
    [SET_LOCALES]: (state, action) => ({
      ...state,
      locales: action.payload
    }),
    [SET_LANGUAGE]: (state, action) => ({
      ...state,
      language: action.payload
    }),
    [SET_COUNTRY]: (state, action) => ({
      ...state,
      country: action.payload
    }),
    [SET_LOGO]: (state, action) => ({
      ...state,
      logo: action.payload
    })
  },
  initialState
)

export const setLanguage = domain => {
  return dispatch => {
    let language = domain === 'se' ? 'sv' : domain === 'com' ? 'en' : domain
    if(!isNaN(language))
      language = 'sv' // If we're on an IP, we'll have to manually set the language
    dispatch(SET_LANGUAGE(language))
    dispatch(setLocales(language))
    Moment.locale(language)
  }
}

export const setCountry = country => {
  return dispatch => {
    dispatch(SET_COUNTRY(country))
    dispatch(setLogo(HylteLogo))
    dispatch(pageActions.setBaseTitle(country))
  }
}

export const setLocales = language => {
  return dispatch => {
    fetch(`/locales/${language}.json`)
      .then(res => res.json())
      .then(json => {
        dispatch(SET_LOCALES(json))
      })
      .catch(error => {
        dispatch(globalMessageActions.setGlobalError(error))
      })
  }
}

export const setLogo = logo => {
  return dispatch => {
    dispatch(SET_LOGO(logo))
  }
}



// WEBPACK FOOTER //
// ./src/store/locales/index.js